module.exports = __webpack_public_path__ + "img/il_Onboarding_Welcome.1955603a.svg";